// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2-0bG","flexRow":"styles_flexRow__3qQ8z","field":"styles_field__2-3Ks","table":"styles_table__3mr_6","row":"styles_row__2_kD6","cell":"styles_cell__1v7GC"};